module.exports = __webpack_public_path__ + "static/media/sad.3093b305.png";